/**
 * ! Only use this for the tailwind config.
 * Since tailwind config follows the CommonJS standard,
 * we are using 'module.exports' syntax with JS.
 */

const PRIMARY_MEDIUM = "#FF5D00";

module.exports = {
  primary: {
    lightest: "#FFF4E6",
    light: "#FFE8D6",
    mediumish: "#FFAB6B",
    medium: PRIMARY_MEDIUM,
    dark: "#E65400",
    darkest: "#63450F",
  },
  complimentary: {
    light: "#00a1ff",
    dark: "#007ACC",
    darker: "#1B325F",
    darkest: "#101112"
  },
  secondary: {
    lightest: "#FF3451",
    light: "#FF3451",
    medium: "#FF3333",
    dark: "#DD2030",
    darkest: "#FF3451",
  },
  neutral: {
    lightmax: "#f8f8f8", // "#f2f2f2",
    lightest: "#E7E7E7",
    light: "#ECEBE7",
    lightish: "#eeeeee",
    medium: "#DDD7CE",
    medium2: "#d9d9d9",
    mediumDark: "#818186",
    dark: "#686559",
    darkest: "#201A15",
  },
  tag: {
    beta: "#FFEE96",
    comingSoon: PRIMARY_MEDIUM,
    planBasic: PRIMARY_MEDIUM,
    planEnterprise: PRIMARY_MEDIUM,
    popular: PRIMARY_MEDIUM,
    activated: "#D1F1E6",
  },
  brand: {
    orange: PRIMARY_MEDIUM,
    dark: "#001134",
    grey: "#F4F4F4",
  },
  successful: {
    lightest: "#D1F1E6",
    light: "#7ACCAF",
    medium: "#48B38E",
    dark: "#3A8C6F",
    darkest: "#2D5342",
  },
  attention: {
    lightest: "#FFE3D9",
    light: "#FFB499",
    medium: "#F27C52",
    dark: "#BF5D3A",
    darkest: "#66321F",
  },
  black: "#000000",
  white: "#FFFFFF",
  red: "#FF3333",
  orange: {
    100: "#FFF4E6",
    200: "#FFE8D6",
  },
  gray: {
    100: "#E6E6E9",
    500: "#808290",
    900: "#010621",
  },
  taupe: {
    600: "#5C5151",
  },
  muted: {
    DEFAULT: "#F4F4F5",
    foreground: "#6B7280",
  },
  accent: {
    DEFAULT: "#F4F0E8",
    background: "#F4F0E8",
    foreground: "#201A15",
  },
};
